import CoreAPIService from './CoreAPIService';

class CustomerCenterService {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }

    async getAnnouncements(data) {
        return this.apiService.get('/announcement', { ...data });
    }

    async getAnnouncementById(id) {
        return this.apiService.get(`/announcement/${id}`);
    }

    async getMemorialNewsList(data) {
        return this.apiService.get('/memorial-news', { ...data });
    }

    async getMemorialNewsById(id) {
        return this.apiService.get(`/memorial-news/${id}`);
    }

    async getFaqList() {
        return this.apiService.get('/faq');
    }

    async getInquiryList(data) {
        return this.apiService.get('/memorial-inquiry/list', { ...data });
    }

    async getInquiryDeatilsById(id) {
        return this.apiService.get(`/memorial-inquiry/detail/${id}`);
    }

    async deleteInquiryById(id) {
        return this.apiService.delete(`/memorial-inquiry/delete/${id}`);
    }

    async updateInquiryById(id, data) {
        return this.apiService.put(`/memorial-inquiry/update/${id}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    //validate password for inquiry
    async validateInquiryPassword(id, data) {
        return this.apiService.post(`/memorial-inquiry/validate-password/${id}`, data);
    }

    async postInquiry(data) {
        return this.apiService.post('/memorial-inquiry/write', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }



}

export default new CustomerCenterService();
